import feedbackActions from "./actions";

const initialState = {
  questionsAndOptionsFeedback : [],
  feedbackSubmitAnswer : []
}

const feedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case feedbackActions.SET_FEEDBACK_QUESTIONS:
      return {
        ...state,
        questionsAndOptionsFeedback : action.payload
      }
    case feedbackActions.GET_FEEDBACK_SUBMIT_ANSWER:
      return {
        ...state,
        feedbackSubmitAnswer : action.payload
      }
    default :
      return state;
  }
}

export default feedbackReducer;